import {User} from '../models/user.model';

export interface AuthState {
  user: User | null;
  isLoggedIn: boolean;
  isLoading: boolean;
  error: any;
}

export const authInitialState: AuthState = {
  user: null,
  isLoggedIn: false,
  isLoading: false,
  error: null
};